import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer'; // necessary for react-hook-inview (ie11)

import React from 'react';
import { render } from 'react-dom';
import queryString from 'query-string';

import App from './app';
import { StoreProvider } from './store';

import './styles.scss';

const parsed = queryString.parse(window.location.search);
const prestamoStorage = window.sessionStorage.getItem('itau-prestamo');

// NOTE: Si llega con un prestamo distinto al del storage, borrar storage
if (parsed?.prestamo !== prestamoStorage) {
  window.sessionStorage.setItem('itau-prestamos-form', '{}');
  window.sessionStorage.setItem('itau-prestamo', '');

  console.log('[LOG]: Registro borrado');
}

// TODO: Borra el storage pero no cambia la seleccion de primera

const storage = window.sessionStorage.getItem('itau-prestamos-form');
const state = JSON.parse(storage);

window.sessionStorage.setItem('itau-prestamo', parsed?.prestamo);

const initialData = {
  prestamo: parsed?.prestamo || 'consumo',
  monto: parsed?.monto || state?.data?.monto || '-',
  moneda: parsed.moneda || state?.data?.moneda || '',
  plazo: parsed.plazo || state?.data?.plazo || '-',
  destino: parsed.destino || state?.data?.destino || 'Consumo',
  title: '', // NOTE: Para cambiar el title del panel segun la oferta seleccionada (solo /consumo)
  // valor_propiedad: data?.valor_propiedad || '-',
  // valor_auto: data?.valor_auto || '-',
  // condicion: data?.condicion || '-',
  // marca: data?.marca || '-',
  // modelo: data?.modelo || '-',
};

render(
  <React.StrictMode>
    <StoreProvider initialData={initialData}>
      <App />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('itau-prestamos-form'),
);
